<div class="home-container" [class.with-bg]="showBg">

  <script src="https://npmcdn.com/angular-toastr/dist/angular-toastr.tpls.js"></script>

  <link rel="stylesheet" href="https://npmcdn.com/angular-toastr/dist/angular-toastr.css" />

  <div class="px-4" style="margin: 0px auto;">

    <ejs-toast #defaulttoast id='defaulttoast' [position]="position" icon="e-meeting">
      <ng-template #content>
        <div>{{ 'home.text1' | translate : { username: this.userInfo.username } }}</div>
      </ng-template>
      <ng-template #title>
        <div [innerHTML]="safeAvatarSVG">{{ 'home.text2' | translate }}</div>
      </ng-template>
    </ejs-toast>
    <ejs-toast #storyEndToast id='storyEndToast' [position]="position" icon="e-meeting">
      <ng-template #content>
        <div>{{ this.storyFinishMessage }}</div>
      </ng-template>
      <ng-template #title>
        <div>{{ 'home.text3' | translate }}</div>
        <!-- <div [innerHTML]="safeAvatarSVG">Adaptive Tiles Meeting</div> -->
      </ng-template>
    </ejs-toast>

    <div class="in-progress-container">
      <div class="in-progress-story-card" *ngIf="showInProgressStory">
        <h2 class="card-title">{{ 'home.text5' | translate }}</h2>
        <app-in-progress-story *ngIf="showInProgressStory" [storybooks]="storybooks" [inProgressStory]="inProgressStory"></app-in-progress-story>
      </div>
    </div>

    <div class="book-list-card">

      <!--  | safe 'html' -->
      <mat-spinner *ngIf="!isStorybooksReady"></mat-spinner>

      <!-- books are there, show books page -->
      <app-book-list *ngIf="isStorybooksReady" [books]="storybooks" [storybooks]="storyBooksAsString" [isAssignmentMode]="isAssignmentReadingMode" (bookOpened)="onBookOpen($event)"></app-book-list>

      <!-- books are not there yet, show in progress -->
      <div *ngIf="!storybooks" class="flex items-center justify-center" style="height: 100px;font-size: 24px;"><span>{{ 'home.text7' | translate }}</span></div>
      <div *ngIf="storybooks && storybooks.length == 0" class="flex items-center justify-center" style="height: 100px; font-size: 24px; color: red;"><span>{{ 'home.text8' | translate }}</span></div>

    </div>

    <!-- <div class="button-group align-end mt-3">
      <button *ngIf="teacherLoggedIn" mat-raised-button color="primary" routerLink="/upload"> <mat-icon class="inline-block mr-2">cloud_upload</mat-icon> {{ 'home.text9' | translate }}</button>
    </div> -->
  </div>
</div>
